import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { loadPageViewLogger } from '../firebaseConfig';

// Firebase Analytics only auto-logs a page_view for the initial page load —
// this is a client-only SPA, so navigating between tools via react-router
// never triggers a real page load. Logging manually on every location change
// is what actually makes per-route usage counts show up in Firebase.
// Firebase itself loads after the page goes idle (see firebaseConfig.ts), so
// the first event waits for that; later ones log right away.
export function usePageViewTracking(): void {
  const location = useLocation();

  useEffect(() => {
    loadPageViewLogger().then((logPageView) => {
      if (!logPageView) return;
      logPageView({
        page_path: location.pathname,
        page_location: window.location.href,
        page_title: document.title,
      });
    });
  }, [location.pathname]);
}
